export const readEmpty = async (skip,user) => {
    try{
        const res = await fetch( 
            `${process.env.REACT_APP_BACKEND_URL}/listKontrakandDomisiliToNotify?skip=${skip}&user=${user}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
        const data = await res.json();
        // Check for errors in response
        // return data and error
        return { data, error: null };
    } catch(error){
        throw new Error(error);
    }
}